import { Form, Input } from "antd";
import { noTrailingSpaceAllowedRule } from "utilities/generalUtility";
import { LabeledField } from "../labeledField/labeledField";

export const JobTitleField = ({
  disabled,
  isFormItem = true,
  extraLabel = null,
  style = {},
}) => {
  const renderField = () => (
    <Input
      placeholder="Enter Job Title"
      className="modalInput"
      disabled={disabled}
      style={style}
    />
  );

  if (isFormItem) {
    return (
      <Form.Item
        label="Title"
        name="title"
        rules={[
          { required: true, message: "Please enter job title!" },
          noTrailingSpaceAllowedRule(),
        ]}
      >
        {renderField()}
      </Form.Item>
    );
  }

  return (
    <LabeledField label="Title" required extra={extraLabel}>
      {renderField()}
    </LabeledField>
  );
};
